exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".header-color-bar {\n  background-color: #e1e6ef !important; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/market-level/asean-exchanges/asean-exchanges.component.scss
// module id = ../../../../../src/app/market-level/asean-exchanges/asean-exchanges.component.scss
// module chunks = main